import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CustomIcon } from '.';

import type { IconName } from '@fortawesome/fontawesome-svg-core';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import type { BrandIcon } from 'styles/fontAwesomeIcons/brands';
import type { RegularIcon } from 'styles/fontAwesomeIcons/regular';
import type { SolidIcon } from 'styles/fontAwesomeIcons/solid';

type Icon = ['far', RegularIcon] | ['fas', SolidIcon] | ['fab', BrandIcon];
export type IconProp = SolidIcon | Icon;

type Props = Omit<FontAwesomeIconProps, 'icon' | 'style'> & {
  fixedWidth?: boolean;
  style?: React.CSSProperties | FontAwesomeIconProps['style'];
} & (
    | { icon: string; type: 'block' }
    | { icon: string; type: 'custom' }
    | { icon: IconProp; type?: 'font-awesome' }
  );

const Icon = ({ icon, fixedWidth, type, ...props }: Props) => {
  if (type === 'custom' || (type === 'block' && !/^fa-/.test(icon))) {
    return <CustomIcon {...props} icon={icon} />;
  }

  // find the correct library icon to use
  const iconProp: ['fas' | 'far' | 'fab', IconName] =
    typeof icon === 'string'
      ? ['fas' as const, icon.replace(/^fa-/, '') as IconName]
      : icon;

  const resolvedIcon = findIconDefinition({
    prefix: iconProp[0],
    iconName: iconProp[1]
  });

  // style fixes due to FontAwesome 7 upgrade
  const style = { ...(props.style || {}) } as FontAwesomeIconProps['style'];
  if (!style.width && fixedWidth) style.width = '1.25em';
  if (!style.height) style.height = '1.05em';

  return (
    <FontAwesomeIcon
      {...props}
      icon={resolvedIcon}
      style={style}
      widthAuto={!fixedWidth}
    />
  );
};

export default Icon;
